import React, { useEffect, useState } from "react";
import api from "../lib/api";

/** Authenticated blob rendering: the temporary image never becomes an img URL on the server. */
export default function PrivateRegistrationPhoto({ registrationId, className = "h-40 w-40" }) {
    const [src, setSrc] = useState("");
    useEffect(() => {
        let active = true; let objectUrl = "";
        api.get(`/admin/registrations/${registrationId}/photo`, { responseType: "blob" })
            .then(({ data }) => { if (active) { objectUrl = URL.createObjectURL(data); setSrc(objectUrl); } })
            .catch(() => { if (active) setSrc(""); });
        return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
    }, [registrationId]);
    return src ? <img className={`${className} rounded-xl object-cover`} src={src} alt="Photo fournie" /> : <p className="text-sm text-slate-500">Photo indisponible</p>;
}
